module.exports = __webpack_public_path__ + "static/media/manufacturers-data-blurred.272d940c.png";